import { HHStack } from '@hinge-health/react-component-library';
import { Autocomplete, TextField } from '@mui/material';
import { CONFIGURATION_STATUS_LABELS } from '../constants/partner-data-gateway.constant';
import { ConfigurationStatus } from '../domain/enums';
import { ConfigurationFilters } from '../types';
import { NativeSelectField } from './native-select-field';

export const CONFIGURATION_STATUS_FILTER_TEST_ID =
  'pdg-configuration-status-filter-select';
export const CONFIGURATION_PROVIDER_FILTER_TEST_ID =
  'pdg-configuration-provider-filter-autocomplete';

export interface ConfigurationFilterBarProps {
  filters: ConfigurationFilters;
  onFiltersChange: (filters: ConfigurationFilters) => void;
  dataProviders: string[];
}

const STATUS_OPTIONS = Object.values(ConfigurationStatus).map(status => ({
  value: status,
  label: CONFIGURATION_STATUS_LABELS[status],
}));

export const ConfigurationFilterBar = ({
  filters,
  onFiltersChange,
  dataProviders,
}: ConfigurationFilterBarProps): JSX.Element => (
  <HHStack direction="row" spacing={6} alignItems="center" flexWrap="wrap">
    <NativeSelectField
      label="Status"
      name="configurationStatus"
      testId={CONFIGURATION_STATUS_FILTER_TEST_ID}
      value={filters.status ?? ''}
      options={STATUS_OPTIONS}
      includeBlank
      onChange={(value): void =>
        onFiltersChange({
          ...filters,
          status: value ? (value as ConfigurationStatus) : null,
        })
      }
    />
    <Autocomplete
      data-testid={CONFIGURATION_PROVIDER_FILTER_TEST_ID}
      options={dataProviders}
      value={filters.dataProvider}
      onChange={(_event, value): void =>
        onFiltersChange({ ...filters, dataProvider: value })
      }
      size="small"
      sx={{ minWidth: 220 }}
      renderInput={(params): JSX.Element => (
        <TextField
          {...params}
          label="Data Provider"
          inputProps={{
            ...params.inputProps,
            role: 'combobox',
            name: 'configurationDataProvider',
          }}
        />
      )}
    />
  </HHStack>
);
